import Vue from 'vue';

import Popper from 'vue-popperjs';
import 'vue-popperjs/dist/vue-popper.css';

Vue.component('popper', Popper);